import { FC, HtmlHTMLAttributes } from "react";

import styles from "./styles.module.scss";
import Text from "../Text";

type Props = HtmlHTMLAttributes<HTMLDivElement> & {
    children?: React.ReactNode;
    onRemove?: () => void;
}

const Tag: FC<Props> = ({ children, onRemove }) => {
    return (
        <div className={styles.tag}>
            <Text variant="body-bold" className={styles.content}>
                {children}
            </Text>
            {onRemove && (
                <button
                    type="button"
                    className={styles.removeButton}
                    onClick={(e) => {
                        e.stopPropagation();
                        onRemove();
                    }}
                    aria-label="remove"
                >
                    <div className={styles.removeIcon} />
                </button>
            )}
        </div>
    );
};

export default Tag;